import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// Selectors
import {
    selectSchemasWithoutEventTypeIdExist
    // @ts-ignore
} from 'services/schemas/selectors';

export interface OwnProps {
    children: React.ReactNode;
    FallbackComponent?: React.ReactNode;
}

interface StateProps {
    schemasWithoutEventTypeIdExist?: boolean;
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class SchemasWithoutEventTypeIdExistGate extends React.PureComponent<
    IProps
> {
    render() {
        const {
            children,
            FallbackComponent,
            schemasWithoutEventTypeIdExist
        } = this.props;
        if (!schemasWithoutEventTypeIdExist) return FallbackComponent || null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    schemasWithoutEventTypeIdExist: selectSchemasWithoutEventTypeIdExist
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    SchemasWithoutEventTypeIdExistGate
);
